/**
 * RETOBLOCK BLE CONNECTION MODAL - GIAO DIỆN DÀNH CHO NGƯỜI DÙNG CUỐI (END USER)
 * Cung cấp hướng dẫn trực quan 3 bước, quét và kết nối trực tiếp xe phần cứng RETOCAR qua Web Bluetooth API.
 */

export class BleModal {
  constructor(options) {
    this.container = options.container;
    this.bleTransport = options.bleTransport;
    this.onConnected = options.onConnected;

    this.init();
  }

  init() {
    this.container.innerHTML = `
      <div class="modal-overlay" id="ble-modal-overlay">
        <div class="modal-card ble-dialog-modal">
          <div class="modal-header">
            <div class="modal-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" stroke-width="2"><path d="m7 7 10 10-5 5V2l5 5L7 17"/></svg>
              <span>KẾT NỐI XE ROBOT RETOCAR</span>
            </div>
            <button class="btn-close-modal" id="btn-close-ble-modal" title="Đóng">&times;</button>
          </div>

          <div class="modal-body" id="ble-modal-body">
            <!-- Rendered dynamically by renderBody() -->
          </div>

          <div class="modal-footer">
            <button class="btn-secondary-modal" id="btn-close-ble-footer">Đóng</button>
          </div>
        </div>
      </div>
    `;

    this.bindGlobalEvents();
  }

  bindGlobalEvents() {
    const overlay = document.getElementById('ble-modal-overlay');
    const closeBtn = document.getElementById('btn-close-ble-modal');
    const footerCloseBtn = document.getElementById('btn-close-ble-footer');

    const close = () => {
      this.hide();
    };

    closeBtn.addEventListener('click', close);
    footerCloseBtn.addEventListener('click', close);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        this.hide();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        this.hide();
      }
    });
  }

  show() {
    const overlay = document.getElementById('ble-modal-overlay');
    if (!overlay) return;
    overlay.classList.add('active');
    this.renderBody();
  }

  hide() {
    const overlay = document.getElementById('ble-modal-overlay');
    if (overlay) {
      overlay.classList.remove('active');
    }
  }

  renderBody() {
    const bodyEl = document.getElementById('ble-modal-body');
    if (!bodyEl) return;

    if (this.bleTransport.isConnected) {
      this.renderConnectedView(bodyEl);
    } else {
      this.renderDisconnectedView(bodyEl);
    }
  }

  renderConnectedView(bodyEl) {
    const devName = this.bleTransport.deviceName || 'RETOCAR';

    bodyEl.innerHTML = `
      <div class="ble-connected-card">
        <div class="ble-robot-avatar">
          <div class="avatar-ring"></div>
          🤖
        </div>

        <div class="ble-connected-info">
          <div class="ble-connected-name">${devName}</div>
          <div class="ble-connected-badge">
            <span class="pulse-dot"></span> Đã kết nối • Sẵn sàng chạy lệnh
          </div>
          <div class="ble-connected-hint">
            Bấm nút chuông để xe kêu bíp và nháy đèn, giúp bạn nhận diện đúng xe của mình trong lớp học.
          </div>
        </div>

        <div class="ble-connected-actions">
          <button class="btn-ping-large" id="btn-ping-connected" title="Kêu bíp và nháy đèn nhận diện xe">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>
            <span>Rung Chuông & Nháy Đèn</span>
          </button>
          <button class="btn-disconnect-modal" id="btn-disconnect-connected">
            Ngắt kết nối
          </button>
        </div>
      </div>
    `;

    const pingBtn = document.getElementById('btn-ping-connected');
    if (pingBtn) {
      pingBtn.addEventListener('click', () => {
        if (this.bleTransport.connectedDevice) {
          this.bleTransport.sendPing(this.bleTransport.connectedDevice);
        } else {
          this.bleTransport.sendPing({ name: devName });
        }
        pingBtn.style.transform = 'scale(0.96)';
        setTimeout(() => {
          pingBtn.style.transform = '';
        }, 150);
      });
    }

    const disconnectBtn = document.getElementById('btn-disconnect-connected');
    if (disconnectBtn) {
      disconnectBtn.addEventListener('click', () => {
        this.bleTransport.disconnect();
        this.renderBody();
      });
    }
  }

  renderDisconnectedView(bodyEl) {
    bodyEl.innerHTML = `
      <div class="ble-guide-container">
        <div class="ble-guide-intro">
          Kết nối xe robot qua Bluetooth không dây để nạp chương trình và tương tác theo thời gian thực.
        </div>

        <div class="ble-steps-list">
          <div class="ble-step-item">
            <div class="ble-step-num">1</div>
            <div class="ble-step-content">
              <div class="ble-step-title">Bật nguồn xe Robot</div>
              <div class="ble-step-desc">Gạt công tắc nguồn trên xe. Xe sẽ phát 2 tiếng bíp tít-tít và đèn LED sáng.</div>
            </div>
          </div>

          <div class="ble-step-item">
            <div class="ble-step-num">2</div>
            <div class="ble-step-content">
              <div class="ble-step-title">Bật Bluetooth trên máy tính</div>
              <div class="ble-step-desc">Đảm bảo máy tính hoặc máy tính bảng của bạn đã bật kết nối Bluetooth.</div>
            </div>
          </div>

          <div class="ble-step-item">
            <div class="ble-step-num">3</div>
            <div class="ble-step-content">
              <div class="ble-step-title">Chọn xe của bạn</div>
              <div class="ble-step-desc">Bấm nút bên dưới và chọn thiết bị có tên dạng <strong>RETOCAR_XXXX</strong>.</div>
            </div>
          </div>
        </div>

        <div id="ble-connection-status-msg" class="ble-status-msg" style="display: none;"></div>

        <div class="ble-action-row">
          <button class="btn-primary-large" id="btn-scan-connect-ble">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
            <span id="scan-btn-text">Tìm & Kết Nối Robot</span>
          </button>
        </div>

        <div class="ble-browser-note">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
          <span>Hỗ trợ tốt nhất trên trình duyệt Google Chrome và Microsoft Edge.</span>
        </div>
      </div>
    `;

    const scanBtn = document.getElementById('btn-scan-connect-ble');
    if (scanBtn) {
      scanBtn.addEventListener('click', () => {
        this.handleScanAndConnect();
      });
    }
  }

  showStatusMessage(message, type = 'info') {
    const msgEl = document.getElementById('ble-connection-status-msg');
    if (!msgEl) return;
    msgEl.textContent = message;
    msgEl.className = `ble-status-msg ${type}`;
    msgEl.style.display = 'block';
  }

  hideStatusMessage() {
    const msgEl = document.getElementById('ble-connection-status-msg');
    if (msgEl) {
      msgEl.style.display = 'none';
    }
  }

  async handleScanAndConnect() {
    const scanBtn = document.getElementById('btn-scan-connect-ble');
    const scanBtnText = document.getElementById('scan-btn-text');
    this.hideStatusMessage();

    if (!navigator.bluetooth && !this.bleTransport.isMockMode) {
      this.showStatusMessage(
        'Trình duyệt này chưa hỗ trợ Web Bluetooth. Vui lòng mở ứng dụng bằng Google Chrome hoặc Microsoft Edge trên thiết bị có Bluetooth.',
        'warning'
      );
      return;
    }

    if (scanBtn) {
      scanBtn.disabled = true;
      if (scanBtnText) scanBtnText.textContent = 'Đang mở cửa sổ Bluetooth...';
    }

    try {
      const devices = await this.bleTransport.scanDevices();

      if (!devices || devices.length === 0) {
        // Người dùng đã đóng/hủy hộp thoại picker
        if (scanBtn) {
          scanBtn.disabled = false;
          if (scanBtnText) scanBtnText.textContent = 'Tìm & Kết Nối Robot';
        }
        this.showStatusMessage('Đã đóng cửa sổ quét. Bấm lại nút khi bạn sẵn sàng kết nối.', 'info');
        return;
      }

      const targetDevice = devices[0];
      if (scanBtnText) scanBtnText.textContent = `Đang kết nối tới ${targetDevice.name}...`;

      await this.bleTransport.connect(targetDevice);

      if (this.onConnected) {
        this.onConnected(targetDevice);
      }

      // Cập nhật giao diện sang trạng thái đã kết nối
      this.renderBody();
    } catch (err) {
      console.error('[BLE CONNECT ERROR]', err);
      if (scanBtn) {
        scanBtn.disabled = false;
        if (scanBtnText) scanBtnText.textContent = 'Tìm & Kết Nối Robot';
      }
      this.showStatusMessage(err.message || 'Không thể kết nối tới xe Robot. Vui lòng kiểm tra lại nguồn xe.', 'error');
    }
  }
}
